
import { SET_CURRENCIES } from "../actions/actionTypes";

const initialState = {
  currencies: null,
};
function CurrencyReducer(state = initialState, action) {
  switch (action.type) {
    case SET_CURRENCIES:
      return {
        ...state,
        currencies: action.payload,
      };
    default:
      return state;
  }
}
export default CurrencyReducer;
